// src/runtime/ContentStrategyRuntime/runtime.ts
// ============================================
// ContentStrategyRuntime - IRuntime 实现
//
// 依据白皮书第十四章《Content Protocol》：
//   在内容工厂生成之前，先生成"策略简报（Platform Brief）"。
//   生成流程强制：品牌选择 → 平台选择 → 内容目标 → 知识检索 → 策略简报 → 素材生成 → 发布
// ============================================

import { RuntimeName } from '../../types/runtime';
import type { IRuntime, RuntimeStatus, RuntimeInfo, RuntimeEvent } from '../../types/runtime';
import { ContentStrategyService } from './service';
import { ContentStrategyQuery, ContentStrategyCommand } from './types';
import config from './config';

export class ContentStrategyRuntime implements IRuntime {
  readonly name = RuntimeName.ContentStrategy;
  status: RuntimeStatus = 'idle';
  private service: ContentStrategyService;
  private startTime: number = Date.now();

  constructor(runtimeManager: any = null) {
    this.service = new ContentStrategyService(runtimeManager, console);
  }

  async initialize(): Promise<void> {
    this.status = 'loading';
    await this.service.initialize();
    this.status = 'ready';
    console.log('[ContentStrategyRuntime] ✅ Initialized');
  }

  async destroy?(): Promise<void> {
    this.status = 'stopped';
    console.log('[ContentStrategyRuntime] Destroyed');
  }

  async query<T>(params?: unknown): Promise<T> {
    const { type, ...rest } = params as {
      type: ContentStrategyQuery;
      [key: string]: any;
    };
    const result = await this.service.query(type, rest);
    return result as unknown as T;
  }

  async execute<T>(command: string, params?: unknown): Promise<T> {
    const result = await this.service.execute(
      command as ContentStrategyCommand,
      (params as Record<string, any>) || {}
    );
    return result as unknown as T;
  }

  getInfo(): RuntimeInfo {
    return {
      name: this.name,
      version: config.version,
      status: this.status,
      health: this.status === 'ready' ? 'healthy' : 'unknown',
      description: config.description,
      uptime: Math.floor((Date.now() - this.startTime) / 1000),
    };
  }

  on?(_event: RuntimeEvent, _callback: (payload: any) => void): void {
    // 预留
  }
}

export default ContentStrategyRuntime;
